module.exports = __webpack_public_path__ + "img/top2@2x.3787235d.png";